import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ShareName_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', id: string, name: string };

export type ShareName_CollectionShare_Fragment = { __typename?: 'CollectionShare', id: string, name: string };

export type ShareNameFragment = ShareName_AdHocAssetsShare_Fragment | ShareName_CollectionShare_Fragment;

export const ShareName = /*#__PURE__*/ gql`
    fragment ShareName on Share {
  id
  name
}
    ` as unknown as DocumentNode<ShareNameFragment, unknown>;

        

        
export const useShareNameFragment = (
  input: string | Omit<UseFragmentOptions<ShareNameFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareNameFragment>({
    fragment: ShareName,
    fragmentName: 'ShareName',
    ...options,
  });
};
  
        